import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import clsx from 'clsx';
import { withStyles } from '@material-ui/core';

const styles = theme => ({
  rootContainer: {
    position: 'relative',
    width: '100%',
    overflowX: 'hidden'
  },
  scrollContainer: {
    overflowX: 'hidden',
    overflowY: 'auto',
    marginRight: -7
  },
  colorBody: {
    backgroundColor: theme.palette.background.default
  },
  colorPanel: {
    backgroundColor: theme.palette.background.paper
  },
  colorPrimary: {
    backgroundColor: theme.palette.primary.main
  },
  colorSecondary: {
    backgroundColor: theme.palette.secondary.main
  },
  topbottomMask: {
    position: 'absolute',
    width: 7,
    height: 16
  },
  rightleftMask: {
    position: 'absolute',
    display: 'inline-block',
    width: 10, // 3,
    height: '100%'
  },
  topPosition: {
    top: 0,
    right: 0
  },
  bottomPosition: {
    right: 0,
    bottom: 0
  },
  leftPosition: {
    top: 0,
    right: 7
  }
});

class Scroll extends Component {
  constructor (props) {
    super(props);

    this.state = {
      isScrollable: false
    }

    if (!props.scrollRef) {
      this.scrollRef = React.createRef();
    }
  }

  componentDidUpdate (prevProps, prevState) {
    const scrollRef = this.scrollRef || this.props.scrollRef;
    if (this.props.location !== prevProps.location) {
      ReactDOM.findDOMNode(scrollRef.current).scrollTop = 0;
    }
    const { scrollHeight, clientHeight } = scrollRef.current;
    const isScrollable = scrollHeight > clientHeight;
    if (prevState.isScrollable !== isScrollable) {
      this.setState({ isScrollable });
    }
  }

  render () {
    const { classes, height, type, typeHeight = 'maxHeight' } = this.props;

    return (
      <div className={classes.rootContainer}>
        <div
          className={classes.scrollContainer}
          style={{ [typeHeight]: height }}
          ref={this.scrollRef || this.props.scrollRef}
        >
          { this.props.children }
        </div>
        {this.state.isScrollable && (
          <>
            <div className={clsx(classes.topPosition, classes.topbottomMask, {
						  [classes.colorPanel]: (type === 'panel'),
						  [classes.colorBody]: (type === 'body'),
						  [classes.colorPrimary]: (type === 'primary'),
						  [classes.colorSecondary]: (type === 'secondary')
            })} />
            <div className={clsx(classes.leftPosition, classes.rightleftMask, {
						  [classes.colorPanel]: (type === 'panel'),
						  [classes.colorBody]: (type === 'body'),
						  [classes.colorPrimary]: (type === 'primary'),
						  [classes.colorSecondary]: (type === 'secondary')
            })} />
            <div className={clsx(classes.bottomPosition, classes.topbottomMask, {
						  [classes.colorPanel]: (type === 'panel'),
						  [classes.colorBody]: (type === 'body'),
						  [classes.colorPrimary]: (type === 'primary'),
						  [classes.colorSecondary]: (type === 'secondary')
            })} />
          </>
        )}
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(Scroll);
